import { Theme } from '@mui/material';

export const styles = {
  heroContainer: {
    minHeight: '30vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    py: 1
  },

  profileImage: {
    width: 250,
    height: 250,
    borderRadius: '24px',
    mb: 1,
    objectFit: 'cover',
    objectPosition: 'center 30%',
    border: '4px solid #fff',
    boxShadow: '0 10px 20px rgba(0,0,0,0.1)',
    transition: 'transform 0.3s ease',
    '&:hover': {
      transform: 'scale(1.05)'
    }
  },

  gradientText: {
    mb: 1,
    fontWeight: 700,
    background: 'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent'
  },

  subtitle: {
    mb: 1
  },

  locationText: {
    mb: 1,
    fontSize: '1rem',
    color: 'text.secondary'
  },

  chipContainer: {
    display: 'flex',
    gap: 0.5,
    flexWrap: 'wrap',
    justifyContent: 'center'
  },

  chip: {
    background: (theme: Theme) => theme.palette.primary.main,
    color: (theme: Theme) => theme.palette.primary.contrastText,
    fontWeight: 500
  },

  noteContainer: {
    textAlign: 'center',
    py: 1.5,
    px: 2,
    mt: 2,
    mb: -2,
    borderRadius: 2,
    // dynamic background and border for dark mode; light mode retains original tint
    background: (theme: Theme) =>
      theme.palette.mode === 'dark'
        ? theme.palette.background.paper
        : 'rgba(33, 150, 243, 0.1)',
    border: (theme: Theme) =>
      theme.palette.mode === 'dark'
        ? `1px solid ${theme.palette.divider}`
        : '1px dashed #2196F3',
    color: (theme: Theme) => theme.palette.text.primary
  },

  section: {
    py: 2
  },

  sectionTitle: {
    mb: 1,
    fontWeight: 700,
    textAlign: 'center'
  },

  glassCard: {
    p: 1.5,
    borderRadius: 4,
    background: (theme: Theme) => theme.palette.background.paper,
    color: (theme: Theme) => theme.palette.text.primary,
    backdropFilter: 'blur(10px)',
    border: (theme: Theme) => `1px solid ${theme.palette.divider}`
  },

  experienceCard: {
    p: 2,
    height: '100%',
    textAlign: 'center',
    cursor: 'pointer',
    borderRadius: 4,
    background: (theme: Theme) => theme.palette.background.paper,
    color: (theme: Theme) => theme.palette.text.primary,
    backdropFilter: 'blur(10px)',
    border: (theme: Theme) => `1px solid ${theme.palette.divider}`,
    transition: 'all 0.3s ease',
    '&:hover': {
      transform: 'translateY(-8px)',
      boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
      background: 'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)',
      '& .MuiTypography-root': {
        color: 'white'
      },
      '& .MuiSvgIcon-root': {
        color: 'white'
      }
    }
  }
} as const;
